module.exports = __webpack_public_path__ + "static/media/PM16.f93ab07e.png";